import config from "./config";

let DB;

export default {

	/*async clearDB() {
		const db = await this.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readwrite");

			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("apirequests");
			store.clear();
		});
	},*/

	async getDb() {
		return new Promise((resolve, reject) => {
			if (DB) {
				return resolve(DB);
			}
			// console.log('OPENING DB', DB);
			const request = window.indexedDB.open(config.DB_NAME, config.DB_VERSION);

			request.onerror = (/*e*/) => {
				// Vue.prototype.$log.info.call(null , 'Error opening db');
				// Vue.prototype.$log.info.call(null , 'Error opening db');

				reject("Error");
			};

			request.onsuccess = (e) => {
				DB = e.target.result;
				resolve(DB);
			};

			request.onupgradeneeded = (e) => {
				// console.log('onupgradeneeded');
				const db = e.target.result;
				if(e.oldVersion < 1) {
					db.createObjectStore("apirequests", { autoIncrement: true, keyPath: "url" });
				}
				if(e.oldVersion < 2) {
					db.createObjectStore("general", { autoIncrement: true, keyPath: "id" });
				}
				if(e.oldVersion < 3) {
					db.createObjectStore("retryrequests", { autoIncrement: true });
				}
			};
		});
	},
};
